import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'
import FormSubstancia from './formSubstancia'

const CadastroSubstancia = ()=> {

  const colunas = [
    {
      dataField: 'substancia_id',
      text: 'Código'
    },
    {
      dataField: 'substancia',
      text: 'Substância'
    },
    {
      dataField: 'lista',
      text: 'Lista'
    }
  ]

  const { SearchBar }                         = Search
  const [loading, setLoading]                 = useState(true)
  const [modal, setModal]                     = useToggle()
  const [substancia_id, setsubstancia_id]     = useState('')
  const [listaSubstancia, setListaSubstancia] = useState([])

  const listaSubstancias = () => {
    let lista = []
    const url = rotas.substancia
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success === 'S'){
          lista = ret.lista
          setListaSubstancia(lista)
          setLoading(false)
        }
      })
      return (lista)

    }catch(err){

    }
  }

  // const pesquisaSubstancia = (type, filtros) => {
  //   let parametros
  //   if(type === 'search') {
  //     parametros = {
  //       todos: 'N',
  //       substancia: filtros.searchText
  //     }
  //   }

  //   if(type === 'pagination'){
  //     parametros = {
  //       todos: 'S',
  //       paginacao: {pagina:filtros.page}
  //     }
  //   }

  //   const url     = rotas.substancias,
  //         retorno = rest.post(url, parametros)

  //   retorno.then(ret => {
  //     if (ret.success){
  //       setListaSubstancia(ret.lista)
  //     }
  //   })
  // }

  useEffect(() => {
    const load = loading
    if (load === true) {
      listaSubstancias()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  //abrir modal do formulario
  const abreModal = (substancia_id) => {
    setsubstancia_id(substancia_id)
    setModal()
  }

  useEffect(() => {
    if(modal===false){
      listaSubstancias()
    }
  }, [modal]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>CADASTRO DE SUBSTÂNCIAS</CardTitle>
                </CardHeader>
                <CardBody>
                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Substâncias</ModalHeader>
                    <FormSubstancia
                      substancia_id = {substancia_id}
                      fechaModal    = {setModal}
                    ></FormSubstancia>
                  </Modal>
                  <ToolkitProvider
                    keyField  = "substancia_id"
                    data      = {listaSubstancia}
                    columns   = {colunas}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                  outline
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Substância..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            // remote
                            keyField          = 'premio_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            pagination        = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            // data              = {listaSubstancia}
                            // onTableChange     = { pesquisaSubstancia }
                            rowStyle          = {{ cursor: "pointer" }}
                            rowEvents         = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.substancia_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br/>
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default CadastroSubstancia
